
import { call, put, takeEvery } from 'redux-saga/effects';
import { message } from 'antd';
import googleDrive from '../Actions/googleDrive';
import { saveGoogleDriveConfigRequest, getGoogleDriveConfigRequest, revokeGoogleDriveRequest } from '../Api/GoogleDrive';
import { startLoading, stopLoading } from '../LoadingHelper';
const { types, actions } = googleDrive;
const { setGoogleData } = actions;

export function* saveGoogleDriveData({data}) {    
    const loadingId = yield call(startLoading, 'googleDriveLoading');
    try {
        const response = yield call(saveGoogleDriveConfigRequest, data);
        if(response.status === 'success') {
            yield call (getGoogleDriveData);
            message.success("La cuenta se ha vinculado exitosamente a Google Drive", 5);
        } else 
            message.error(response.message, 5);            
    } catch (error) {
        message.error(error.message, 5);
    } finally {
        yield call(stopLoading, loadingId);
    }
}

export function* getGoogleDriveData() {
    const loadingId = yield call(startLoading, 'googleDriveLoading'); 
    try {        
        const response = yield call(getGoogleDriveConfigRequest);
        if(response.status === 'success' && response.data !== null) {
            yield put(setGoogleData(response.data)); 
        } else {
            yield put(setGoogleData({name: '',email: '',image: ''})); 
        }
    } catch (error) {
        message.error(error.message, 5);
    } finally { 
        yield call(stopLoading, loadingId);
    }
}

export function* revokeGoogleAccess() {
    const loadingId = yield call(startLoading, 'googleDriveLoading'); 
    try {        
        const response = yield call(revokeGoogleDriveRequest);
        console.log('response ', response);
        if(response.status === 'success') {
            message.success('La cuenta ha sido desvinculada correctamente', 5);
            yield put(setGoogleData({name: '',email: '',image: ''}));
            window.location.reload();
        } else {
            message.error(response.messageDetail, 5);
        }
    } catch (error) {
        message.error(error.message, 5);
    } finally { 
        yield call(stopLoading, loadingId);
    }
}

export function* googleDriveSaga() {
    yield takeEvery(types.SAVE_GOOGLE_DATA, saveGoogleDriveData);
    yield takeEvery(types.GET_GOOGLE_DATA, getGoogleDriveData);
    yield takeEvery(types.REVOKE_GOOGLE_ACCESS, revokeGoogleAccess);
    
};
